import React, { useContext, useEffect } from "react";
import { Grid, useMediaQuery, useTheme, Typography } from "@mui/material";

import { TestStoreContext } from "../contexts/testStoreContext";
import { hasPlayedBefore } from "../util/webStorage";
import { LangContext } from "../contexts/langContext";
import BackgroundOrbs from "../features/BackgroundOrbs";
import AlignCenter from "../components/AlignCenter";
import StyledButton from "../components/StyledButton";
import { useNavigate, useParams } from "react-router-dom";
import { getQuestionFromId } from "@natklok/util/questionUtils";
import useGenerateOneQuestionQuiz from "@natklok/hooks/useGenerateOneQuestionQuiz";
import { useQuestions } from "@natklok/hooks/useQuestions";

const PreReferredQuestionSlide: React.FC = () => {
  const { setReferredToQuestion } = useContext(TestStoreContext);
  const { translatePageText } = useContext(LangContext);
  const { questionid } = useParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { translateTranslationData } = useContext(LangContext);
  const navigate = useNavigate();
  // TODO COMPLETE: Add questions
  // TODO: Re-make to load question from slug?
  const { data: questionsData, isLoading } = useQuestions();
  const questions = questionsData ?? [];
  const question = getQuestionFromId({ questionId: questionid || "", questions });
  const generateOneQuestionQuiz = useGenerateOneQuestionQuiz();

  useEffect(() => {
    if (question) {
      setReferredToQuestion(questionid);
    } else if (!isLoading) {
      navigate("/question-not-found");
    }
  });

  if (!question) return null;

  return (
    <>
      <div style={{ zIndex: 5, position: "relative" }}>
        <AlignCenter withMaxWidth centerBothAxis>
          <Grid container>
            <Grid
              item
              xs={12}
              md={12}
              display="flex"
              flexDirection="column"
              textAlign="center"
              justifyContent="center"
              height={"60vh"}
            >
              <h2
                style={{
                  fontWeight: "normal",
                  fontSize: "1.1em",
                  margin: 0,
                  padding: 0,
                  opacity: 0.7,
                }}
              >
                {translatePageText("test.answerTheQuestion")}
              </h2>
              <Typography
                style={{
                  margin: "5px 0 30px 0",
                  padding: 0,
                }}
                variant="h4"
              >
                {translateTranslationData(question.title)}
              </Typography>
              <StyledButton
                onClick={() => {
                  if (!hasPlayedBefore()) {
                    navigate("/settings");
                  } else {
                    generateOneQuestionQuiz(question.id.sv);
                  }
                }}
                style={{
                  padding: "14px 30px",
                }}
                label={translatePageText("test.openTheQuestion")}
              />
            </Grid>
          </Grid>{" "}
        </AlignCenter>
      </div>
      {!isMobile && <BackgroundOrbs />}
    </>
  );
};

export default PreReferredQuestionSlide;
